/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useContext } from 'react';
import { StackContext } from './contexts';
import compose from 'lib/compose';
import Panel from './Panel';

const is = (name) => (v) => v.type === name;
const has = (key) => (v) => v[key];
const filter = (pred) => (v) => v.filter(pred);

const getOwn = compose(
  filter(is('markup')),
  filter(has('markup'))
);

export type MarkupT = {
  markup: string,
  type: string,
  title: string,
  uuid: string,
  category_type: string,
};

// Markup Panels
// -------------------
//
// {
//   type: 'markup',
//   title: 'Foo',
//   markup: '<div>hello world</div>',
// }

const Component = ({
  setInternalUpdate,
  internalUpdate,
}: {
  internalUpdate: any,
  setInternalUpdate: Function,
}): null | Element<string> => {
  const legends = useContext(StackContext);
  const ownLegends = getOwn(legends);
  if (ownLegends.isEmpty()) return null;
  const mkItem = (v, k) => (
    <Panel
      type="markup"
      title={v.title}
      markup={v.markup}
      key={k}
      historyFilters={{}}
      category_type={v.category_type}
      uuid={v.uuid}
      setInternalUpdate={setInternalUpdate}
      internalUpdate={internalUpdate}
    />
  );
  let ol = ownLegends.toJS();
  if (!Array.isArray(ol)) return null;
  ol = ((ol: any): MarkupT[]);
  return <div css={bubbleLegendCss}>{ol.map(mkItem)}</div>;
};
export default Component;

const bubbleLegendCss = css(`
  margin-top: 8px;
  margin-bottom: 16px;
  .legend-panel {
    padding-left: 10px;
  }

  ul {
    padding: 0;
    list-style: none;
  }

  .CDB-Size-small {
    font-size: 12px;
    line-height: 8px;
  }

  .u-flex {
    display: flex;
  }

  .u-justifySpace {
    justify-content: space-between;
  }

  .Bubble-container {
    display: flex;
    max-height: 100px;
    padding-top: 3px;
    padding-bottom: 8px;
  }

  .Bubble-numbers {
    position: relative;
  }

  .Bubble-numbersItem {
    position: absolute;
    margin-bottom: -11px;
    padding-right: 16px;
    background: rgba(255, 255, 255, 0.8);
    z-index: 10;
  }

  .Bubble-inner {
    display: flex;
    position: relative;
  }

  .Bubble-list {
    display: flex;
    justify-content: center;
    position: relative;
    width: 100px;
    height: 100px;
  }

  .Bubble-item {
    opacity: 0.5;
    transform: translateX(-50%);
    position: absolute;
    bottom: 0;
    left: 50%;
  }

  .Bubble-item::before {
    position: absolute;
    top: 5px;
    right: 50%;
    width: 140px;
    height: 1px;
    background: rgba(0, 0, 0, 0.08);
    content: '';
  }

  .Bubble-itemCircle {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    background: #f8ab17;
    box-shadow: -1px 0 2px 0 rgba(0, 0, 0, 0.1);
    pointer-events: none;
  }
`);
